import React from 'react';
import PropTypes from 'prop-types';
import WalkThrough from '@fiverr-private/walkthrough/src/Walkthrough';
import WalkThroughIntro from '../WalkThroughIntro';
import './style.scss';

export default function WalkthroughWrapper({ steps, handleSeenWalkThrough }) {
    return (
        <WalkThrough className="collaboration-driver"
            dismissable={true}
            onComplete={() => handleSeenWalkThrough(true)}
            onAlreadySeen={() => handleSeenWalkThrough(true)}
            steps={steps}>
            {({ startTour }) => (
                <WalkThroughIntro startTour={startTour}/>
            )}
        </WalkThrough>
    );
}

WalkthroughWrapper.propTypes = {
    steps: PropTypes.array.isRequired,
    handleSeenWalkThrough: PropTypes.func
};

WalkthroughWrapper.defaultProps = {
    handleSeenWalkThrough: () => null
};
